export const GET_ATTRIBUTE_COLLECTION_START = "@attributeCollection/GET_ATTRIBUTE_COLLECTION_START";
export const GET_ATTRIBUTE_COLLECTION_SUCCESS =
  "@attributeCollection/GET_ATTRIBUTE_COLLECTION_SUCCESS";
export const GET_ATTRIBUTE_COLLECTION_FAIL = "@attributeCollection/GET_ATTRIBUTE_COLLECTION_FAIL";
export const GET_DETAIL_COLLECTION_START = "@attributeCollection/GET_DETAIL_COLLECTION_START";
export const GET_DETAIL_COLLECTION_SUCCESS = "@attributeCollection/GET_DETAIL_COLLECTION_SUCCESS";
export const GET_DETAIL_COLLECTION_FAIL = "@attributeCollection/GET_DETAIL_COLLECTION_FAIL";
export const GET_LIST_START = "@attributeCollection/GET_LIST_START";
export const GET_LIST_SUCCESS = "@attributeCollection/GET_LIST_SUCCESS";
export const GET_LIST_FAIL = "@attributeCollection/GET_LIST_FAIL";
export const GET_COLLECTION_TYPES_SUCCESS = "@attributeCollection/GET_COLLECTION_TYPES_SUCCESS";
export const GET_COLLECTION_TYPES_START = "@attributeCollection/GET_COLLECTION_TYPES_START";
export const GET_COLLECTION_TYPES_FAIL = "@attributeCollection/GET_COLLECTION_TYPES_FAIL";
export const GET_TYPES_FAMILY_SUCCESS = "@attributeCollection/GET_TYPES_FAMILY_SUCCESS";
export const GET_TYPES_FAMILY_START = "@attributeCollection/GET_TYPES_FAMILY_START";
export const GET_TYPES_FAMILY_FAIL = "@attributeCollection/GET_TYPES_FAMILY_FAIL";
